import {
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { api } from '@/api';
import { END_POINT } from '@/constants/end-point.constants';
import { BILLING_INFORMATION_QUERY_KEYS } from '@/constants/query-keys.constants';

import type { BillingInformationRequest } from '../types';

const fetchBillingInformationDetail = async (
  id: string,
): Promise<AxiosResponse<BillingInformationRequest>> =>
  api.get(END_POINT.organizationBillingInformation(id));

export const useBillingInformationDetail = (
  id: string,
  { enabled = true }: Partial<UseQueryOptions>,
) =>
  useQuery({
    queryKey: BILLING_INFORMATION_QUERY_KEYS.detail(id),
    queryFn: enabled ? () => fetchBillingInformationDetail(id) : skipToken,
    select: data => data.data,
  });
